import { computed } from 'vue';
import { useRoute, type RouteLocationNormalizedLoaded } from 'vue-router';
import { defaultNavItems } from '~/composables/mobile/useMobileNavItems';

export const useMobileTabKey = (providedRoute?: RouteLocationNormalizedLoaded) => {
  const route = providedRoute ?? useRoute();

  const tabKey = computed(() => {
    for (const navItem of defaultNavItems) {
      if (route.path === navItem.path || route.path.startsWith(navItem.path + '/')) {
        return navItem.path;
      }
    }
    return '/';
  });

  return { tabKey };
};

